export const CREATE_PLAN = "CREATE_PLAN";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_FAIL = "CREATE_PLAN_FAIL";
